import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Home from './components/Home';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import Signup from './components/Signup';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import Ship from './components/mkt/Ship';
import Partners from './components/mkt/Partners';
import Product from './components/mkt/Product';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <UserProvider>
        <Router>
          <div className="App" style={{ paddingTop: 'var(--header-h)' }}>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={
                <section className="cp-section">
                  <div className="cp-container" style={{ maxWidth: 760 }}>
                    <PrivacyPolicy />
                  </div>
                </section>
              } />
              <Route path="/signup" element={<Signup />} />

              {/* Canonical product page */}

              {/* /resources redirects rather than 404s: it was live and is
                  indexed. It advertised a blog, documentation and a changelog,
                  none of which exist — a nav item promising three things that
                  are not there costs more trust than the page ever earned.
                  Restore it when there is something behind it. */}
              <Route path="/resources" element={<Navigate to="/contact" replace />} />
              <Route path="/ship" element={<Ship />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/product" element={<Product />} />

              {/* Backwards-compatible redirects */}
              {/* Every legacy product URL consolidates onto /product so the SEO follows. */}
              <Route path="/products/communication" element={<Navigate to="/product" replace />} />
              <Route path="/products/route-optimization" element={<Navigate to="/product" replace />} />
              <Route path="/products/iot" element={<Navigate to="/product" replace />} />
              <Route path="/products/messaging" element={<Navigate to="/product" replace />} />
              <Route path="/coplaid-msg" element={<Navigate to="/product" replace />} />
              <Route path="/route-optimization" element={<Navigate to="/product" replace />} />
              {/* Pricing is not published — the platform is sold through partners, so
                  the number depends on the partner agreement. Old links land on contact
                  rather than 404ing. */}
              <Route path="/pricing" element={<Navigate to="/contact" replace />} />
              {/* /customers held a template case study with invented metrics and a
                  placeholder testimonial. Retired until a real customer agrees to
                  be named. */}
              <Route path="/customers" element={<Navigate to="/" replace />} />
              <Route path="/newhome" element={<Navigate to="/" replace />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </UserProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
